import React from "react";
import {Button} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Typography from '@material-ui/core/Typography';
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles/index";
import UserAvatar from "../../../user-avatar/UserAvatar";
import {useMediaQuery} from "@material-ui/core/index";
import {useTheme} from "@material-ui/core/styles";
import Hidden from '@material-ui/core/Hidden';
import {Providers} from "./Providers";
import {useNavigate} from "react-router-dom";
import {Provider} from "../../../../models/pro-guest.models";
import {useCapability} from "../../../../auth/CapabilityContext";
import {Roles} from "../../../../auth/roles";

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    actionColumn: {
        maxWidth: 150,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& > *': {
            marginLeft: '10px',
        }
    }
}));

interface ProvidersBrowserProps {
    organizationId: number;
    folderId: number | string;
}

export const ProvidersBrowser: React.FC<ProvidersBrowserProps> = ({
                                                                      organizationId,
                                                                      folderId
                                                                  }) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const theme = useTheme();
    const {hasRole} = useCapability();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const isAdmin = hasRole(Roles.ADMIN);

    const openProvider = (provider: Provider) => {
        navigate(`/pro-guests/providers/${provider.id}/guests?folderId=${folderId}`);
    };

    const addExternalProvider = () => {
        navigate(`/pro-guests/external-providers/add?folderId=${folderId}`)
    }

    const row = (provider: Provider) => <TableRow
        onClick={() => isAdmin && isMobile && openProvider(provider)}
        key={provider.userId}>
        <TableCell component="th" scope="row" className={classes.avatarColumn}>
            <UserAvatar userId={provider.userId}/>
        </TableCell>
        <TableCell>
            <Typography variant="body1">{provider.firstName} {provider.lastName}</Typography>
            <Typography variant="body2"
                        color={'textPrimary'}>{provider.email}</Typography>
        </TableCell>
        <TableCell>
            <Typography
                variant="body1">{t(`ProGuest.Providers.${provider.isEnabled ? 'Active' : 'Inactive'}`)}</Typography>
        </TableCell>
        {isAdmin &&
        <TableCell className={classes.actionColumn} align="center">
            <Button color="primary" size="small"
                    onClick={() => openProvider(provider)}>
                {t('_Common.Labels.Open')}
            </Button>
        </TableCell>
        }

    </TableRow>;

    const header = <TableRow>
        <TableCell className={classes.avatarColumn}></TableCell>
        <TableCell>{t('ProGuest.Providers.Table.Headers.User')}</TableCell>
        <TableCell size='small'>{t('ProGuest.Providers.Table.Headers.Status')}</TableCell>
        {isAdmin && <TableCell className={classes.actionColumn}></TableCell>}
    </TableRow>;

    return <Grid container spacing={3}>
        <Grid item xs={12} className={classes.actionRow}>
            <Button variant="contained" color="primary" size="medium"
                    onClick={addExternalProvider}>
                {t('ProGuest.AddProviders.AddBtn')}
            </Button>
        </Grid>
        <Providers
            organizationId={organizationId}
            folderId={folderId}
            isFolderProviderSearch={true}
            headerRender={() => header}
            rowRender={row}
        />
    </Grid>
};
